import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

interface Parameter {
    setQty: boolean;
    qty?: number;
    productCopyPaste?: string;
    shouldClear?: boolean;
}

type HandlerType = Handler<Parameter, void>;

export const DispatchProductInfoQty: HandlerType = props => {
    const { setQty, qty } = props.parameter;
    if (setQty && qty) {
        props.dispatch({
            type: "Custom/ProductInformation/SetProductSelectQty",
            qty,
        } as any);
        props.dispatch({
            type: "Custom/ProductInformation/SetProductCopyPaste",
            info: "",
        } as any);
    }
};

export const DispatchProductInfoCopyPaste: HandlerType = props => {
    const { setQty, productCopyPaste: info } = props.parameter;
    if (!setQty && info != null) {
        props.dispatch({
            type: "Custom/ProductInformation/SetProductSelectQty",
            qty: -1,
        } as any);
        props.dispatch({
            type: "Custom/ProductInformation/SetProductCopyPaste",
            info,
        } as any);
    }
};

export const DispatchProductInfoClear: HandlerType = props => {
    if (props.parameter.shouldClear) {
        props.dispatch({
            type: "Custom/ProductInformation/ClearProductSelect",
        } as any);
    }
};

export const chain = [DispatchProductInfoQty, DispatchProductInfoCopyPaste, DispatchProductInfoClear];

const setQuickOrderInformation = createHandlerChainRunner(chain, "SetQuickOrderInformation");
export default setQuickOrderInformation;
